import React, { useEffect, useState } from "react";
import { useAppSelector } from "hooks/reduxHooks";
import {
  selectPatientRegionDetails,
  selectExamMLResultLeftKnee,
  selectExamMLResultRightKnee,
  selectExamMLResultDoubleKnee,
  selectExamList,
} from "store/PatientStore/selectors";
import Skeleton from "react-loading-skeleton";
import { RegionBlock } from "../../components/Athlete/RegionBlock";
import { selectRequests } from "../../../../store/LoadingStore/selectors";
import { Requests } from "../../../../types/requests";
import { PatientRegionDetail, ScoreConfig } from "types/PatientRegion";
import { RegionBlockSingleKnee } from "pages/PatientDetails/components/Athlete/RegionBlockSingleKnee";
import { RegionChart } from "pages/PatientDetails/components/Athlete/RegionChart";
import { RegionChartSingleKnee } from "pages/PatientDetails/components/Athlete/RegionChartSingleKnee";

export const AthleteRegionDetails = () => {
  const patientRegionDetails = useAppSelector(selectPatientRegionDetails);
  const examMLResultLeftKnee = useAppSelector(selectExamMLResultLeftKnee);
  const examMLResultRightKnee = useAppSelector(selectExamMLResultRightKnee);
  const examMLResultDoubleKnee = useAppSelector(selectExamMLResultDoubleKnee);
  const examList = useAppSelector(selectExamList);

  const isFreeForm = window.location.search.includes("freeForm=true");
  const loading = useAppSelector((state) =>
    selectRequests([Requests.getPatientRegionDetails], state)
  );

  const [
    patientRegionLeftKneeDetailsProcessed,
    setPatientRegionLeftKneeDetailsProcessed,
  ] = useState<any>();
  const [
    patientRegionRightKneeDetailsProcessed,
    setPatientRegionRightKneeDetailsProcessed,
  ] = useState<any>();
  const [
    patientRegionDoubleKneeDetailsProcessed,
    setPatientRegionDoubleKneeDetailsProcessed,
  ] = useState<any>();

  function processPatientRegionDetails(
    patientRegionDetails: PatientRegionDetail[]
  ) {
    for (let i = 0; i < patientRegionDetails.length; i++) {
      if (patientRegionDetails[i].region._id == "62e1962c9f293b927973f92c") {
        setPatientRegionDoubleKneeDetailsProcessed({
          ...patientRegionDetails[i],
        });
      }
      if (
        patientRegionDetails[i].region._id == "624d9c5f3a7e5392abe5f78d" ||
        patientRegionDetails[i].region._id == "626e5b6ff613a8eac4cf72ff"
      ) {
        setPatientRegionRightKneeDetailsProcessed({
          ...patientRegionDetails[i],
        });
      }
      if (
        patientRegionDetails[i].region._id == "624d9d053a7e5392abe5f78e" ||
        patientRegionDetails[i].region._id == "626e5b81f613a8eac4cf7300"
      ) {
        setPatientRegionLeftKneeDetailsProcessed({
          ...patientRegionDetails[i],
        });
      }
    }
  }

  useEffect(() => {
    if (patientRegionDetails.length > 0) {
      processPatientRegionDetails(patientRegionDetails);
    }
  }, [patientRegionDetails]);

  return (
    <div>
      {loading ? (
        <div className="flex flex-col mt-5 space-y-5">
          <Skeleton height={300} />
          <Skeleton height={300} />
        </div>
      ) : (
        <>
          {patientRegionDoubleKneeDetailsProcessed && (
            <div className="flex flex-col card w-full p-8 rounded-[20px] mt-5">
              <RegionBlock
                title={
                  patientRegionDoubleKneeDetailsProcessed.region.joint.name
                }
                subtitle={
                  patientRegionDoubleKneeDetailsProcessed.region.joint.side
                }
                week={patientRegionDoubleKneeDetailsProcessed.week}
                videoExamsQuantity={
                  examList.filter(
                    (exam) =>
                      exam.examType === "dynamic" &&
                      exam.joint.name === "bothKnees"
                  ).length
                }
                lastExam={
                  patientRegionDoubleKneeDetailsProcessed.lastExam || ""
                }
                score={patientRegionDoubleKneeDetailsProcessed.outcomeScore}
              />
              <RegionChart
                examMLResultDoubleKnee={examMLResultDoubleKnee}
                title={""}
              />
            </div>
          )}

          {(patientRegionRightKneeDetailsProcessed ||
            patientRegionLeftKneeDetailsProcessed) && (
            <div className="flex flex-col card w-full p-8 rounded-[20px] mt-5">
              <RegionBlockSingleKnee
                patientRegionRightKneeDetailsProcessed={
                  patientRegionRightKneeDetailsProcessed
                }
                patientRegionLeftKneeDetailsProcessed={
                  patientRegionLeftKneeDetailsProcessed
                }
              />
              <RegionChartSingleKnee
                examMLResultRightKnee={examMLResultRightKnee}
                examMLResultLeftKnee={examMLResultLeftKnee}
                title={""}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};
